import {getIds} from "./getIds.js";
export const hasActivePerson = (search, columnIndex) => {
  const ids = getIds();
  return ids[columnIndex] === search;
};
